export const isAdminOfEnterprise = (
  member: {
    idEnterprisesAdmin?: string[];
  },
  idEnterprise: string,
): boolean => {
  return !!member?.idEnterprisesAdmin?.includes(idEnterprise);
};
